import { useCallback, useEffect, useState } from 'react';
import { fetchActivityLogs } from '../api/activityLogs';
import type { ActivityLog } from '../types';

export const useActivityLogs = (shopifyCustomerId: string) => {
  const [activityLogs, setActivityLogs] = useState<ActivityLog[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [page, setPage] = useState(1);
  const [perPage, setPerPage] = useState(10);
  const [total, setTotal] = useState(0);
  const [category, setCategory] = useState<string>('');
  const [level, setLevel] = useState<string>('');

  const fetchData = useCallback(async () => {
    if (!shopifyCustomerId) return;

    await Promise.resolve();
    setLoading(true);
    setError(null);
    try {
      const res = await fetchActivityLogs(
        shopifyCustomerId,
        page,
        perPage,
        category || undefined,
        level || undefined,
      );
      setActivityLogs(res.items);
      setTotal(res.pagination.total);
    } catch (err) {
      setError(err instanceof Error ? err.message : 'An error occurred');
      setActivityLogs([]);
    } finally {
      setLoading(false);
    }
  }, [shopifyCustomerId, page, perPage, category, level]);

  useEffect(() => {
    void Promise.resolve().then(fetchData);
  }, [fetchData]);

  return {
    activityLogs,
    loading,
    error,
    page,
    total,
    perPage,
    totalPages: Math.ceil(total / perPage),
    category,
    level,
    handlePageChange: (newPage: number) => setPage(newPage),
    handlePerPageChange: (newPerPage: number) => {
      setPerPage(newPerPage);
      setPage(1);
    },
    handleCategoryChange: (newCategory: string) => {
      setCategory(newCategory);
      setPage(1);
    },
    handleLevelChange: (newLevel: string) => {
      setLevel(newLevel);
      setPage(1);
    },
    refetch: fetchData,
  };
};
